import { useTranslation } from 'react-i18next'
import { useState, useEffect } from 'react'
import SubVisual from '../../components/SubVisual'
import ImgDoppleLife from '../../assets/images/dopplmate/dopplife.png'
import ImgDoppleGanger from '../../assets/images/dopplmate/doppelganger.png'
import ImgSoulmate1 from '../../assets/images/dopplmate/soulmate1.png'
import ImgSoulmate2 from '../../assets/images/dopplmate/soulmate2.png'
import Img01 from '../../assets/images/dopplemate/01.png'
import Img02 from '../../assets/images/dopplemate/02.png'
import Img03 from '../../assets/images/dopplemate/03.png'

const imgArr = [
	{
		name: 'Android',
		svg: (
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<path
					d="M6 18c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5S6 24.828 6 24v-6zm17 0c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5v-6z"
					fill="#3DDC84"
				/>
				<path
					d="M10 16h12v10a2 2 0 01-2 2h-1v3h-2v-3h-2v3h-2v-3h-1a2 2 0 01-2-2V16z"
					fill="#3DDC84"
				/>
				<path
					d="M20.414 7l1.293-1.293a1 1 0 00-1.414-1.414L18.586 6A7.98 7.98 0 0016 5c-.898 0-1.759.148-2.586.42l-1.707-1.707a1 1 0 00-1.414 1.414L11.586 7A8 8 0 008 13v2h16v-2a8 8 0 00-3.586-6zM13 11a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2z"
					fill="#10B981"
				/>
			</svg>
		),
		color: '#3DDC84',
	},
	{
		name: 'AI',
		svg: (
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<path
					d="M16 4a1 1 0 011 1v2a1 1 0 11-2 0V5a1 1 0 011-1zm8.66 3.34a1 1 0 010 1.41l-1.42 1.42a1 1 0 01-1.41-1.42l1.42-1.41a1 1 0 011.41 0zM28 15a1 1 0 010 2h-2a1 1 0 110-2h2zM7.34 7.34a1 1 0 011.41 0l1.42 1.42a1 1 0 01-1.42 1.41L7.34 8.76a1 1 0 010-1.42zM6 15a1 1 0 100 2H4a1 1 0 110-2h2z"
					fill="#A78BFA"
				/>
				<circle
					cx="16"
					cy="16"
					r="6"
					fill="#C084FC"
				/>
				<path
					d="M11 20a3 3 0 016 0v5a3 3 0 11-6 0v-5z"
					fill="#E879F9"
					opacity="0.7"
				/>
			</svg>
		),
		color: '#C084FC',
	},
	{
		name: 'AR',
		svg: (
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<path
					d="M4 10a2 2 0 012-2h4a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm16 0a2 2 0 012-2h4a2 2 0 012 2v2a2 2 0 01-2 2h-4a2 2 0 01-2-2v-2zM4 20a2 2 0 012-2h4a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm16 0a2 2 0 012-2h4a2 2 0 012 2v2a2 2 0 01-2 2h-4a2 2 0 01-2-2v-2z"
					fill="#22D3EE"
					opacity="0.5"
				/>
				<circle
					cx="16"
					cy="16"
					r="5"
					stroke="#06B6D4"
					strokeWidth="2"
					fill="none"
				/>
				<path
					d="M16 11v10M11 16h10"
					stroke="#0EA5E9"
					strokeWidth="2"
				/>
			</svg>
		),
		color: '#22D3EE',
	},
	{
		name: 'Agent',
		svg: (
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<circle
					cx="16"
					cy="10"
					r="5"
					fill="#818CF8"
				/>
				<path
					d="M8 24c0-4.418 3.582-8 8-8s8 3.582 8 8v4H8v-4z"
					fill="#6366F1"
				/>
				<circle
					cx="16"
					cy="16"
					r="2"
					fill="#A5B4FC"
					opacity="0.5"
				/>
				<path
					d="M20 16l3-3m-14 3l-3-3"
					stroke="#8B5CF6"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
			</svg>
		),
		color: '#818CF8',
	},
	{
		name: 'Game Engine',
		svg: (
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<rect
					x="6"
					y="10"
					width="20"
					height="12"
					rx="3"
					stroke="#F87171"
					strokeWidth="2"
					fill="none"
				/>
				<circle
					cx="11"
					cy="16"
					r="2"
					fill="#FB923C"
				/>
				<circle
					cx="21"
					cy="14"
					r="1.5"
					fill="#FBBF24"
				/>
				<circle
					cx="21"
					cy="18"
					r="1.5"
					fill="#FBBF24"
				/>
				<path
					d="M15 13h2M16 12v2"
					stroke="#F87171"
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
			</svg>
		),
		color: '#FB923C',
	},
	{
		name: 'WEB',
		svg: (
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<circle
					cx="16"
					cy="16"
					r="11"
					stroke="#60A5FA"
					strokeWidth="2"
					fill="none"
				/>
				<path
					d="M16 5c-3 0-5.5 4.925-5.5 11s2.5 11 5.5 11 5.5-4.925 5.5-11S19 5 16 5z"
					stroke="#818CF8"
					strokeWidth="2"
					fill="none"
				/>
				<path
					d="M6 16h20M8 11h16M8 21h16"
					stroke="#3B82F6"
					strokeWidth="2"
					strokeLinecap="round"
				/>
			</svg>
		),
		color: '#60A5FA',
	},
	{
		name: 'iOS',
		svg: (
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
			>
				<rect
					x="7"
					y="4"
					width="18"
					height="24"
					rx="3"
					stroke="#94A3B8"
					strokeWidth="2"
					fill="none"
				/>
				<rect
					x="10"
					y="7"
					width="12"
					height="18"
					rx="1"
					fill="#64748B"
					opacity="0.3"
				/>
				<circle
					cx="16"
					cy="25.5"
					r="1"
					fill="#94A3B8"
				/>
			</svg>
		),
		color: '#94A3B8',
	},
]

const Dopplemate = () => {
	const { t } = useTranslation()
	const [rotate, setRotate] = useState(0)
	const [visibleSections, setVisibleSections] = useState<Set<string>>(new Set())

	// 스크롤 이벤트 최적화 - requestAnimationFrame 사용
	useEffect(() => {
		let rafId: number | null = null
		let lastScrollY = window.scrollY

		const handleScroll = () => {
			lastScrollY = window.scrollY

			if (rafId === null) {
				rafId = requestAnimationFrame(() => {
					setRotate(lastScrollY / 10)
					rafId = null
				})
			}
		}

		// passive 이벤트 리스너로 성능 향상
		window.addEventListener('scroll', handleScroll, { passive: true })

		return () => {
			window.removeEventListener('scroll', handleScroll)
			if (rafId !== null) {
				cancelAnimationFrame(rafId)
			}
		}
	}, [])

	// IntersectionObserver 최적화
	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				setVisibleSections((prev) => {
					const updates = new Set(prev)
					let hasChanges = false

					entries.forEach((entry) => {
						if (entry.isIntersecting && !updates.has(entry.target.id)) {
							updates.add(entry.target.id)
							hasChanges = true
						}
					})

					return hasChanges ? updates : prev
				})
			},
			{
				threshold: 0.1,
				rootMargin: '0px 0px -100px 0px',
			},
		)

		const sections = document.querySelectorAll('[data-observe]')
		sections.forEach((section) => observer.observe(section))

		return () => observer.disconnect()
	}, [])
	return (
		<div className="min-h-screen bg-gradient-to-br from-gray-900 via-indigo-900/20 to-gray-900 text-white overflow-x-hidden">
			{/* 서브 비주얼 */}
			<SubVisual
				backgroundVideo="/videos/dopple.mp4"
				title={t('page.dopplemate.title')}
				subtitle={t('page.dopplemate.description')}
				height="h-[60vh]"
				overlayOpacity={0.6}
			/>

			<section
				id="intro"
				data-observe
				className={`relative py-32 px-6 lg:px-12 transition-all duration-1000 will-change-[opacity,transform] ${
					visibleSections.has('intro')
						? 'opacity-100 translate-y-0'
						: 'opacity-0 translate-y-20'
				}`}
			>
				{/* 배경 그라데이션 */}
				<div className="absolute inset-0 bg-gradient-to-b from-transparent via-indigo-950/20 to-transparent pointer-events-none" />

				<div className="relative container mx-auto max-w-6xl">
					{/* 메인 타이틀 */}
					<div className="text-center mb-12">
						<h2 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-4 eng-bold">
							<span className="bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
								DOPPLE
							</span>
							<br />
							<span className="text-2xl md:text-3xl lg:text-4xl text-gray-400 font-light">
								VNS
							</span>{' '}
							<span className="bg-gradient-to-r from-purple-400 via-pink-400 to-rose-400 bg-clip-text text-transparent">
								MATE
							</span>
						</h2>
						<p className="text-xl md:text-2xl text-gray-300 font-medium mt-6">
							{t('page.dopplemate.txt1')}
						</p>
						<p className="text-lg text-indigo-400 tracking-[0.3em] mt-2 font-semibold">
							VIRTUAL NARRATIVE SOCIAL
						</p>
					</div>

					{/* 피처 그리드 */}
					<div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4 my-12">
						<div className="group bg-gradient-to-br from-indigo-500/10 to-purple-600/10 backdrop-blur-sm rounded-xl p-4 border border-indigo-500/30 hover:border-indigo-400/60 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-indigo-500/20 text-center">
							<div className="w-10 h-10 mx-auto mb-2 rounded-full bg-indigo-500/20 flex items-center justify-center">
								<svg
									className="w-5 h-5 text-indigo-400"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
									/>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
									/>
								</svg>
							</div>
							<span className="text-xs font-bold text-indigo-300 tracking-wider">
								MMO RPG GAME
							</span>
						</div>
						<div className="group bg-gradient-to-br from-purple-500/10 to-pink-600/10 backdrop-blur-sm rounded-xl p-4 border border-purple-500/30 hover:border-purple-400/60 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-purple-500/20 text-center">
							<div className="w-10 h-10 mx-auto mb-2 rounded-full bg-purple-500/20 flex items-center justify-center">
								<svg
									className="w-5 h-5 text-purple-400"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
									/>
								</svg>
							</div>
							<span className="text-xs font-bold text-purple-300 tracking-wider">
								MESSENGER
							</span>
						</div>
						<div className="group bg-gradient-to-br from-pink-500/10 to-rose-600/10 backdrop-blur-sm rounded-xl p-4 border border-pink-500/30 hover:border-pink-400/60 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-pink-500/20 text-center">
							<div className="w-10 h-10 mx-auto mb-2 rounded-full bg-pink-500/20 flex items-center justify-center">
								<svg
									className="w-5 h-5 text-pink-400"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
									/>
								</svg>
							</div>
							<span className="text-xs font-bold text-pink-300 tracking-wider">
								COMMUNITY
							</span>
						</div>
						<div className="group bg-gradient-to-br from-rose-500/10 to-orange-600/10 backdrop-blur-sm rounded-xl p-4 border border-rose-500/30 hover:border-rose-400/60 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-rose-500/20 text-center">
							<div className="w-10 h-10 mx-auto mb-2 rounded-full bg-rose-500/20 flex items-center justify-center">
								<svg
									className="w-5 h-5 text-rose-400"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
									/>
								</svg>
							</div>
							<span className="text-xs font-bold text-rose-300 tracking-wider">
								PRIVATE FEED
							</span>
						</div>
						<div className="group bg-gradient-to-br from-amber-500/10 to-yellow-600/10 backdrop-blur-sm rounded-xl p-4 border border-amber-500/30 hover:border-amber-400/60 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-amber-500/20 text-center">
							<div className="w-10 h-10 mx-auto mb-2 rounded-full bg-amber-500/20 flex items-center justify-center">
								<svg
									className="w-5 h-5 text-amber-400"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
									/>
								</svg>
							</div>
							<span className="text-xs font-bold text-amber-300 tracking-wider">
								RELATIONSHIP
							</span>
						</div>
						<div className="group bg-gradient-to-br from-emerald-500/10 to-teal-600/10 backdrop-blur-sm rounded-xl p-4 border border-emerald-500/30 hover:border-emerald-400/60 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-emerald-500/20 text-center">
							<div className="w-10 h-10 mx-auto mb-2 rounded-full bg-emerald-500/20 flex items-center justify-center">
								<svg
									className="w-5 h-5 text-emerald-400"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
									/>
								</svg>
							</div>
							<span className="text-xs font-bold text-emerald-300 tracking-wider">
								VIRTUAL MAP
							</span>
						</div>
						<div className="group bg-gradient-to-br from-cyan-500/10 to-blue-600/10 backdrop-blur-sm rounded-xl p-4 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/20 text-center">
							<div className="w-10 h-10 mx-auto mb-2 rounded-full bg-cyan-500/20 flex items-center justify-center">
								<svg
									className="w-5 h-5 text-cyan-400"
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
									/>
								</svg>
							</div>
							<span className="text-xs font-bold text-cyan-300 tracking-wider">
								AI SOULMATE
							</span>
						</div>
					</div>

					{/* 설명 텍스트 */}
					<div className="max-w-4xl mx-auto">
						<div className="bg-gray-800/30 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-indigo-500/20">
							<p className="text-lg md:text-xl text-gray-300 leading-relaxed text-center">
								{t('page.dopplemate.txt2')}{' '}
								<span className="font-semibold text-indigo-400">
									{t('page.dopplemate.txt3')}
								</span>
								{t('page.dopplemate.txt4')}
								{t('page.dopplemate.txt5')}{' '}
								<span className="font-semibold text-purple-400">
									{t('page.dopplemate.txt6')}
								</span>
								{t('page.dopplemate.txt7')}
							</p>
						</div>
					</div>
				</div>
			</section>

			{/* Multi Platform Section */}
			<section
				id="multi-platform"
				data-observe
				className={`relative py-32 px-6 lg:px-12 transition-all duration-1000 will-change-[opacity,transform] ${
					visibleSections.has('multi-platform')
						? 'opacity-100 translate-y-0'
						: 'opacity-0 translate-y-20'
				}`}
			>
				{/* Animated background gradient */}
				<div className="absolute inset-0 bg-gradient-to-b from-transparent via-indigo-950/20 to-transparent pointer-events-none" />
				<div className="absolute inset-0 overflow-hidden pointer-events-none">
					<div className="absolute top-1/4 -left-48 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl animate-pulse will-change-[opacity] transform-gpu" />
					<div
						className="absolute bottom-1/4 -right-48 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl animate-pulse will-change-[opacity] transform-gpu"
						style={{ animationDelay: '1s' }}
					/>
				</div>

				<div className="container mx-auto relative z-10">
					<div className="text-center mb-20">
						<div className="inline-flex items-center px-6 py-3 bg-indigo-500/10 rounded-full border border-indigo-400/20 mb-6">
							<span className="text-indigo-300 text-sm font-medium tracking-wide">
								MULTI-PLATFORM TECHNOLOGY
							</span>
						</div>
						<h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white via-indigo-200 to-purple-200 text-transparent bg-clip-text">
							{t('page.dopplemate.mt2')}
							<br />
							{t('page.dopplemate.mt3')}
						</h2>
						<p className="text-lg text-gray-300 max-w-2xl mx-auto">
							{t('page.dopplemate.mt4')}{' '}
							<span className="text-indigo-400 font-semibold">
								{t('page.dopplemate.mt5')}
							</span>
							,{' '}
							<span className="text-purple-400 font-semibold">
								{t('page.dopplemate.mt6')}
							</span>
							,{' '}
							<span className="text-blue-400 font-semibold">
								{t('page.dopplemate.mt7')}
							</span>{' '}
							{t('page.dopplemate.mt8')}
						</p>
					</div>

					{/* Mobile Grid View */}
					<div className="lg:hidden grid grid-cols-2 gap-4 px-4 mb-16">
						{imgArr.map((item, i) => (
							<div
								key={i}
								data-observe
								className={`group relative bg-gradient-to-br from-slate-800/60 to-slate-900/60 p-6 rounded-2xl border border-slate-700/50 hover:border-slate-600 transition-all duration-500 will-change-[opacity,transform] transform-gpu ${
									visibleSections.has('multi-platform')
										? 'opacity-100 scale-100'
										: 'opacity-0 scale-90'
								}`}
								style={{
									boxShadow: `0 4px 20px ${item.color}20`,
									transitionDelay: `${i * 80}ms`,
								}}
							>
								<div className="flex flex-col items-center gap-3">
									<div
										className="transform group-hover:scale-110 transition-transform duration-300"
										style={{
											filter: `drop-shadow(0 0 8px ${item.color})`,
										}}
									>
										{item.svg}
									</div>
									<span className="text-xs font-semibold text-gray-100 tracking-wide text-center">
										{item.name}
									</span>
								</div>
							</div>
						))}
					</div>

					{/* Center Platform Card - Mobile */}
					<div
						data-observe
						className={`lg:hidden bg-gradient-to-br from-indigo-900/40 to-purple-900/40 p-8 rounded-3xl border border-indigo-500/30 mb-12 mx-4 transition-all duration-700 ${
							visibleSections.has('multi-platform')
								? 'opacity-100 translate-y-0'
								: 'opacity-0 translate-y-10'
						}`}
						style={{ transitionDelay: '600ms' }}
					>
						<h3 className="text-2xl font-bold mb-6 text-center bg-gradient-to-r from-white via-indigo-100 to-purple-100 text-transparent bg-clip-text">
							Multi Platform
						</h3>
						<div className="grid grid-cols-2 gap-4">
							{['보안', 'App 속도 (60FPS 이상)', '안정성', '미래지향 설계'].map(
								(item, idx) => (
									<div
										key={idx}
										className="flex items-center gap-2 text-sm text-gray-200 bg-slate-800/50 p-3 rounded-xl"
									>
										<div className="w-2 h-2 rounded-full bg-gradient-to-r from-indigo-400 to-purple-400 flex-shrink-0" />
										<span className="text-xs">{item}</span>
									</div>
								),
							)}
						</div>
					</div>

					{/* Rotating Platform Diagram - Desktop */}
					<div className="hidden lg:flex relative justify-center items-center py-24 min-h-[900px]">
						{/* Glow effects */}
						<div className="absolute inset-0 flex justify-center items-center">
							<div className="w-[600px] h-[600px] bg-indigo-600/5 rounded-full blur-3xl" />
						</div>

						<div
							className="relative will-change-transform transform-gpu"
							style={{
								transform: `rotate(${rotate}deg)`,
							}}
						>
							{/* Center Core */}
							<div
								className="relative"
								style={{
									width: '280px',
									height: '280px',
									background:
										'linear-gradient(135deg, rgba(99, 102, 241, 0.4) 0%, rgba(139, 92, 246, 0.3) 50%, rgba(59, 130, 246, 0.2) 100%)',
									borderRadius: '50%',
									position: 'relative',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									boxShadow:
										'0 0 80px rgba(99, 102, 241, 0.3), inset 0 0 60px rgba(99, 102, 241, 0.1)',
									border: '1px solid rgba(129, 140, 248, 0.3)',
								}}
							>
								{/* Inner ring with dots */}
								<div
									className="absolute"
									style={{
										top: '-20px',
										left: '-20px',
										right: '-20px',
										bottom: '-20px',
										borderRadius: '50%',
										border: '1px solid rgba(129, 140, 248, 0.2)',
										background: 'transparent',
										pointerEvents: 'none',
									}}
								/>

								{/* Small orbital dots */}
								{Array.from({ length: 8 }).map((_, i) => {
									const angle = (i * 2 * Math.PI) / 8
									const radius = 150
									const size = 8
									const x = 140 + radius * Math.cos(angle) - size / 2
									const y = 140 + radius * Math.sin(angle) - size / 2
									return (
										<div
											key={i}
											className="absolute animate-pulse"
											style={{
												left: `${x}px`,
												top: `${y}px`,
												width: `${size}px`,
												height: `${size}px`,
												borderRadius: '50%',
												background:
													'linear-gradient(135deg, rgba(129, 140, 248, 0.8), rgba(99, 102, 241, 0.6))',
												boxShadow: '0 0 16px rgba(99, 102, 241, 0.8)',
												animationDelay: `${i * 0.1}s`,
											}}
										/>
									)
								})}

								{/* Center content */}
								<div
									className="text-center relative z-10 px-6 will-change-transform transform-gpu"
									style={{
										transform: `rotate(${-rotate}deg)`,
									}}
								>
									<h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-white via-indigo-100 to-purple-100 text-transparent bg-clip-text">
										{t('page.dopplemate.mp1')}
									</h3>
									<div className="space-y-2">
										{[
											t('page.dopplemate.mp2'),
											t('page.dopplemate.mp3'),
											t('page.dopplemate.mp4'),
											t('page.dopplemate.mp5'),
										].map((item, idx) => (
											<div
												key={idx}
												className="flex items-center justify-center gap-2 text-sm text-gray-200"
											>
												<div className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-indigo-400 to-purple-400" />
												<span>{item}</span>
											</div>
										))}
									</div>
								</div>

								{/* Outer ring */}
								<div
									className="absolute"
									style={{
										top: '-90px',
										left: '-90px',
										right: '-90px',
										bottom: '-90px',
										borderRadius: '50%',
										border: '1px solid rgba(129, 140, 248, 0.15)',
										background: 'transparent',
										pointerEvents: 'none',
									}}
								/>

								{/* Platform Icons */}
								{imgArr.map((item, i) => {
									const angle = (i * 2 * Math.PI) / 7
									const radius = 240
									const size = 110
									const x = 140 + radius * Math.cos(angle) - size / 2
									const y = 140 + radius * Math.sin(angle) - size / 2
									return (
										<div
											key={i}
											className="group cursor-pointer absolute"
											style={{
												left: `${x}px`,
												top: `${y}px`,
												width: `${size}px`,
												height: `${size}px`,
											}}
											onMouseEnter={(e) => {
												const card = e.currentTarget.querySelector(
													'.platform-card',
												) as HTMLElement
												if (card) {
													card.style.transform = 'scale(1.1)'
													card.style.boxShadow = `0 12px 40px ${item.color}60, 0 0 60px ${item.color}40`
													card.style.borderColor = item.color
													card.style.background = `linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(30, 41, 59, 0.8) 100%)`
												}
											}}
											onMouseLeave={(e) => {
												const card = e.currentTarget.querySelector(
													'.platform-card',
												) as HTMLElement
												if (card) {
													card.style.transform = 'scale(1)'
													card.style.boxShadow = `0 4px 20px ${item.color}30, 0 0 30px ${item.color}15`
													card.style.borderColor = `${item.color}40`
													card.style.background = 'rgba(30, 41, 59, 0.6)'
												}
											}}
										>
											<div
												className="platform-card w-full h-full rounded-2xl flex flex-col items-center justify-center gap-3 backdrop-blur-xl"
												style={{
													background: 'rgba(30, 41, 59, 0.6)',
													boxShadow: `0 4px 20px ${item.color}30, 0 0 30px ${item.color}15`,
													border: `1px solid ${item.color}40`,
													transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
												}}
											>
												<div
													className="flex flex-col items-center gap-3 will-change-transform transform-gpu"
													style={{
														transform: `rotate(${-rotate}deg)`,
													}}
												>
													<div
														className="transform group-hover:scale-110 transition-transform duration-300"
														style={{
															filter: `drop-shadow(0 0 12px ${item.color})`,
														}}
													>
														{item.svg}
													</div>
													<span className="text-xs font-semibold text-gray-100 tracking-wide">
														{item.name}
													</span>
												</div>
											</div>
										</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* Optimization Section */}
			<section
				id="optimization"
				data-observe
				className={`relative py-32 px-6 lg:px-12 bg-gradient-to-b from-gray-900 via-slate-900 to-gray-900 transition-all duration-1000 will-change-[opacity,transform] ${
					visibleSections.has('optimization')
						? 'opacity-100 translate-y-0'
						: 'opacity-0 translate-y-20'
				}`}
			>
				<div className="absolute inset-0 bg-grid-white/[0.02] bg-[size:50px_50px]" />

				<div className="container mx-auto relative z-10">
					<div className="text-center mb-16">
						<div className="inline-flex items-center px-6 py-3 bg-emerald-500/10 rounded-full border border-emerald-400/20 mb-6">
							<span className="text-emerald-300 text-sm font-medium tracking-wide">
								{t('page.dopplemate.po1')}
							</span>
						</div>
						<h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white via-emerald-200 to-cyan-200 text-transparent bg-clip-text">
							{t('page.dopplemate.po2')}
						</h2>
						<p className="text-lg text-gray-300 max-w-3xl mx-auto">
							{t('page.dopplemate.po3')} ={' '}
							<span className="text-emerald-400 font-semibold">
								{t('page.dopplemate.po4')}
							</span>
						</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
						{[
							{
								title: 'Query Tuning',
								desc: t('page.dopplemate.po5'),
								color: 'from-blue-500 to-cyan-500',
								icon: (
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
									>
										<path
											d="M20 5L22.5 15H32.5L24.5 21L27 31L20 25L13 31L15.5 21L7.5 15H17.5L20 5Z"
											fill="url(#grad1)"
											stroke="currentColor"
											strokeWidth="2"
										/>
										<defs>
											<linearGradient
												id="grad1"
												x1="20"
												y1="5"
												x2="20"
												y2="31"
												gradientUnits="userSpaceOnUse"
											>
												<stop stopColor="#60A5FA" />
												<stop
													offset="1"
													stopColor="#06B6D4"
												/>
											</linearGradient>
										</defs>
									</svg>
								),
							},
							{
								title: 'Security Optimization',
								desc: t('page.dopplemate.po6'),
								color: 'from-purple-500 to-pink-500',
								icon: (
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
									>
										<rect
											x="13"
											y="18"
											width="14"
											height="12"
											rx="2"
											fill="url(#grad2)"
											stroke="currentColor"
											strokeWidth="2"
										/>
										<path
											d="M16 18V14C16 11.7909 17.7909 10 20 10C22.2091 10 24 11.7909 24 14V18"
											stroke="currentColor"
											strokeWidth="2"
											strokeLinecap="round"
										/>
										<circle
											cx="20"
											cy="24"
											r="2"
											fill="white"
										/>
										<defs>
											<linearGradient
												id="grad2"
												x1="20"
												y1="18"
												x2="20"
												y2="30"
												gradientUnits="userSpaceOnUse"
											>
												<stop stopColor="#A855F7" />
												<stop
													offset="1"
													stopColor="#EC4899"
												/>
											</linearGradient>
										</defs>
									</svg>
								),
							},
							{
								title: 'Program Optimization',
								desc: t('page.dopplemate.po7'),
								color: 'from-emerald-500 to-teal-500',
								icon: (
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
									>
										<circle
											cx="20"
											cy="20"
											r="12"
											fill="url(#grad3)"
											stroke="currentColor"
											strokeWidth="2"
										/>
										<path
											d="M20 14V20L24 24"
											stroke="white"
											strokeWidth="2"
											strokeLinecap="round"
										/>
										<circle
											cx="20"
											cy="8"
											r="1.5"
											fill="currentColor"
										/>
										<circle
											cx="32"
											cy="20"
											r="1.5"
											fill="currentColor"
										/>
										<circle
											cx="20"
											cy="32"
											r="1.5"
											fill="currentColor"
										/>
										<circle
											cx="8"
											cy="20"
											r="1.5"
											fill="currentColor"
										/>
										<defs>
											<linearGradient
												id="grad3"
												x1="20"
												y1="8"
												x2="20"
												y2="32"
												gradientUnits="userSpaceOnUse"
											>
												<stop stopColor="#10B981" />
												<stop
													offset="1"
													stopColor="#14B8A6"
												/>
											</linearGradient>
										</defs>
									</svg>
								),
							},
							{
								title: 'Multilingual Optimization',
								desc: t('page.dopplemate.po8'),
								color: 'from-orange-500 to-red-500',
								icon: (
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
									>
										<circle
											cx="20"
											cy="20"
											r="12"
											stroke="currentColor"
											strokeWidth="2"
											fill="none"
										/>
										<path
											d="M8 20H32"
											stroke="currentColor"
											strokeWidth="2"
										/>
										<path
											d="M20 8C20 8 14 13 14 20C14 27 20 32 20 32"
											stroke="currentColor"
											strokeWidth="2"
											fill="none"
										/>
										<path
											d="M20 8C20 8 26 13 26 20C26 27 20 32 20 32"
											stroke="currentColor"
											strokeWidth="2"
											fill="none"
										/>
										<circle
											cx="20"
											cy="20"
											r="8"
											fill="url(#grad4)"
											opacity="0.3"
										/>
										<defs>
											<linearGradient
												id="grad4"
												x1="20"
												y1="12"
												x2="20"
												y2="28"
												gradientUnits="userSpaceOnUse"
											>
												<stop stopColor="#F97316" />
												<stop
													offset="1"
													stopColor="#EF4444"
												/>
											</linearGradient>
										</defs>
									</svg>
								),
							},
							{
								title: 'Network Optimization',
								desc: t('page.dopplemate.po9'),
								color: 'from-indigo-500 to-blue-500',
								icon: (
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
									>
										<circle
											cx="20"
											cy="28"
											r="3"
											fill="url(#grad5)"
										/>
										<circle
											cx="10"
											cy="18"
											r="2.5"
											fill="url(#grad5)"
										/>
										<circle
											cx="30"
											cy="18"
											r="2.5"
											fill="url(#grad5)"
										/>
										<circle
											cx="15"
											cy="10"
											r="2"
											fill="url(#grad5)"
										/>
										<circle
											cx="25"
											cy="10"
											r="2"
											fill="url(#grad5)"
										/>
										<path
											d="M20 25L10 18M20 25L30 18M10 18L15 10M30 18L25 10"
											stroke="currentColor"
											strokeWidth="2"
											opacity="0.6"
										/>
										<circle
											cx="20"
											cy="28"
											r="5"
											stroke="currentColor"
											strokeWidth="2"
											fill="none"
											opacity="0.3"
										/>
										<defs>
											<linearGradient
												id="grad5"
												x1="20"
												y1="10"
												x2="20"
												y2="28"
												gradientUnits="userSpaceOnUse"
											>
												<stop stopColor="#6366F1" />
												<stop
													offset="1"
													stopColor="#3B82F6"
												/>
											</linearGradient>
										</defs>
									</svg>
								),
							},
							{
								title: 'Real-time Chat Optimization',
								desc: t('page.dopplemate.po10'),
								color: 'from-pink-500 to-rose-500',
								icon: (
									<svg
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
									>
										<rect
											x="8"
											y="10"
											width="24"
											height="18"
											rx="3"
											fill="url(#grad6)"
											stroke="currentColor"
											strokeWidth="2"
										/>
										<path
											d="M16 28L20 32L24 28"
											stroke="currentColor"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<circle
											cx="14"
											cy="19"
											r="1.5"
											fill="white"
										/>
										<circle
											cx="20"
											cy="19"
											r="1.5"
											fill="white"
										/>
										<circle
											cx="26"
											cy="19"
											r="1.5"
											fill="white"
										/>
										<defs>
											<linearGradient
												id="grad6"
												x1="20"
												y1="10"
												x2="20"
												y2="28"
												gradientUnits="userSpaceOnUse"
											>
												<stop stopColor="#EC4899" />
												<stop
													offset="1"
													stopColor="#F43F5E"
												/>
											</linearGradient>
										</defs>
									</svg>
								),
							},
						].map((item, idx) => (
							<div
								key={idx}
								data-observe
								className={`group relative bg-gradient-to-br from-slate-800/50 to-slate-900/50 p-8 rounded-2xl border border-slate-700/50 hover:border-slate-600 transition-all duration-500 will-change-[transform,opacity] transform-gpu hover:scale-105 ${
									visibleSections.has('optimization')
										? 'opacity-100 translate-y-0'
										: 'opacity-0 translate-y-10'
								}`}
								style={{
									transitionDelay: `${idx * 100}ms`,
								}}
							>
								<div
									className={`absolute inset-0 bg-gradient-to-br ${item.color} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-300 pointer-events-none`}
								/>
								<div className="relative z-10">
									<div className="mb-4 flex items-center justify-center w-16 h-16 mx-auto">
										{item.icon}
									</div>
									<h3 className="text-xl font-bold mb-3 text-white">{item.title}</h3>
									<p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* Platform Strategy Section */}
			<section
				id="platform-strategy"
				data-observe
				className={`relative py-32 px-6 lg:px-12 transition-all duration-1000 will-change-[opacity,transform] ${
					visibleSections.has('platform-strategy')
						? 'opacity-100 translate-y-0'
						: 'opacity-0 translate-y-20'
				}`}
			>
				<div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-950/10 to-transparent" />

				<div className="container mx-auto relative z-10">
					<div className="text-center mb-16">
						<div className="inline-flex items-center px-6 py-3 bg-purple-500/10 rounded-full border border-purple-400/20 mb-6">
							<span className="text-purple-300 text-sm font-medium tracking-wide">
								GLOBAL EXPANSION
							</span>
						</div>
						<h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white via-purple-200 to-pink-200 text-transparent bg-clip-text">
							{t('page.dopplemate.ge1')}
						</h2>
						<p className="text-lg text-gray-300 max-w-3xl mx-auto">
							{t('page.dopplemate.ge2')} <br />
							<span className="text-purple-400 font-semibold">
								{t('page.dopplemate.ge3')}
							</span>
						</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
						{[
							{
								img: Img01,
								title: t('page.dopplemate.ge4'),
								subtitle: t('page.dopplemate.ge5'),
							},
							{
								img: Img02,
								title: t('page.dopplemate.ge6'),
								subtitle: t('page.dopplemate.ge7'),
							},
							{
								img: Img03,
								title: t('page.dopplemate.ge8'),
								subtitle: t('page.dopplemate.ge9'),
							},
						].map((item, idx) => (
							<div
								key={idx}
								data-observe
								className={`group relative bg-gradient-to-br from-slate-800/30 to-slate-900/30 rounded-3xl overflow-hidden border border-slate-700/30 hover:border-purple-500/50 transition-all duration-700 ${
									visibleSections.has('platform-strategy')
										? 'opacity-100 translate-y-0'
										: 'opacity-0 translate-y-10'
								}`}
								style={{
									transitionDelay: `${idx * 150}ms`,
								}}
							>
								<div className="relative h-64 overflow-hidden">
									<img
										src={item.img}
										alt={item.title}
										className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
									/>
									<div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent" />
								</div>
								<div className="p-6">
									<h3 className="text-xl font-bold mb-2 text-white">{item.title}</h3>
									<p className="text-gray-400 text-sm leading-relaxed">
										{item.subtitle}
									</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* FTI Matching Section */}
			<section
				id="fti-matching"
				data-observe
				className={`relative py-32 px-6 lg:px-12 bg-gradient-to-b from-gray-900 via-rose-950/10 to-gray-900 transition-all duration-1000 will-change-[opacity,transform] ${
					visibleSections.has('fti-matching')
						? 'opacity-100 translate-y-0'
						: 'opacity-0 translate-y-20'
				}`}
			>
				<div className="container mx-auto relative z-10">
					<div className="text-center mb-16">
						<div className="inline-flex items-center px-6 py-3 bg-rose-500/10 rounded-full border border-rose-400/20 mb-6">
							<span className="text-rose-300 text-sm font-medium tracking-wide">
								{t('page.dopplemate.ai1')}
							</span>
						</div>
						<h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white via-rose-200 to-pink-200 text-transparent bg-clip-text">
							{t('page.dopplemate.ai2')}
						</h2>
						<p className="text-lg text-gray-300 max-w-2xl mx-auto">
							{t('page.dopplemate.ai3')}{' '}
							<span className="text-rose-400 font-semibold">
								{t('page.dopplemate.ai4')}
							</span>
							{t('page.dopplemate.ai5')}
						</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
						{[
							{
								img: ImgDoppleLife,
								title: t('page.dopplemate.ai6'),
								desc: t('page.dopplemate.ai7'),
							},
							{
								img: ImgDoppleGanger,
								title: t('page.dopplemate.ai8'),
								desc: t('page.dopplemate.ai9'),
							},
						].map((item, idx) => (
							<div
								key={idx}
								data-observe
								className={`group relative bg-gradient-to-br from-slate-800/40 to-slate-900/40 rounded-3xl overflow-hidden border border-slate-700/40 hover:border-rose-500/50 transition-all duration-700 ${
									visibleSections.has('fti-matching')
										? 'opacity-100 translate-x-0'
										: idx === 0
											? 'opacity-0 -translate-x-10'
											: 'opacity-0 translate-x-10'
								}`}
								style={{
									transitionDelay: `${idx * 200}ms`,
								}}
							>
								<div className="relative h-80 overflow-hidden">
									<img
										src={item.img}
										alt={item.title}
										className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
									/>
									<div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />
								</div>
								<div className="absolute bottom-0 left-0 right-0 p-8">
									<h3 className="text-2xl font-bold mb-2 text-white">{item.title}</h3>
									<p className="text-gray-300">{item.desc}</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* Messenger Section */}
			<section
				id="messenger"
				data-observe
				className={`relative py-32 px-6 lg:px-12 transition-all duration-1000 will-change-[opacity,transform] ${
					visibleSections.has('messenger')
						? 'opacity-100 translate-y-0'
						: 'opacity-0 translate-y-20'
				}`}
			>
				<div className="container mx-auto relative z-10">
					<div className="text-center mb-16">
						<div className="inline-flex items-center px-6 py-3 bg-cyan-500/10 rounded-full border border-cyan-400/20 mb-6">
							<span className="text-cyan-300 text-sm font-medium tracking-wide">
								{t('page.dopplemate.ms1')}
							</span>
						</div>
						<h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white via-cyan-200 to-blue-200 text-transparent bg-clip-text">
							{t('page.dopplemate.ms2')}
						</h2>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
						{[
							{
								img: ImgSoulmate1,
								title: t('page.dopplemate.ms3'),
								desc: t('page.dopplemate.ms4'),
							},
							{
								img: ImgSoulmate2,
								title: t('page.dopplemate.ms5'),
								desc: t('page.dopplemate.ms6'),
							},
						].map((item, idx) => (
							<div
								key={idx}
								data-observe
								className={`group relative bg-gradient-to-br from-slate-800/40 to-slate-900/40 rounded-3xl overflow-hidden border border-slate-700/40 hover:border-cyan-500/50 transition-all duration-700 ${
									visibleSections.has('messenger')
										? 'opacity-100 translate-x-0'
										: idx === 0
											? 'opacity-0 -translate-x-10'
											: 'opacity-0 translate-x-10'
								}`}
								style={{
									transitionDelay: `${idx * 200}ms`,
								}}
							>
								<div className="relative h-80 overflow-hidden">
									<img
										src={item.img}
										alt={item.title}
										className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
									/>
									<div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />
								</div>
								<div className="absolute bottom-0 left-0 right-0 p-8">
									<h3 className="text-2xl font-bold mb-2 text-white">{item.title}</h3>
									<p className="text-gray-300">{item.desc}</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			{/* AI Profile & Avatar Section */}
			<section
				id="ai-profile"
				data-observe
				className={`relative py-32 px-6 lg:px-12 bg-gradient-to-b from-gray-900 via-violet-950/10 to-gray-900 transition-all duration-1000 will-change-[opacity,transform] ${
					visibleSections.has('ai-profile')
						? 'opacity-100 translate-y-0'
						: 'opacity-0 translate-y-20'
				}`}
			>
				<div className="container mx-auto relative z-10">
					<div className="text-center mb-16">
						<div className="inline-flex items-center px-6 py-3 bg-violet-500/10 rounded-full border border-violet-400/20 mb-6">
							<span className="text-violet-300 text-sm font-medium tracking-wide">
								{t('page.dopplemate.ait1')}
							</span>
						</div>
						<h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white via-violet-200 to-purple-200 text-transparent bg-clip-text">
							{t('page.dopplemate.ait2')}
						</h2>
						<p className="text-lg text-gray-300 max-w-3xl mx-auto mb-8">
							<span className="text-violet-400 font-semibold">
								{t('page.dopplemate.ait3')}
							</span>{' '}
							{t('page.dopplemate.ait4')}
							<br />
							{t('page.dopplemate.ait5')}
						</p>
						<p className="text-sm text-gray-400">{t('page.dopplemate.ait6')}</p>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto">
						<div
							data-observe
							className={`text-center p-8 bg-gradient-to-br from-violet-900/20 to-purple-900/20 rounded-3xl border border-violet-500/20 transition-all duration-700 ${
								visibleSections.has('ai-profile')
									? 'opacity-100 translate-x-0'
									: 'opacity-0 -translate-x-10'
							}`}
							style={{ transitionDelay: '200ms' }}
						>
							<div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-violet-500 to-purple-600 rounded-2xl flex items-center justify-center">
								<svg
									width="48"
									height="48"
									viewBox="0 0 48 48"
									fill="none"
								>
									<circle
										cx="24"
										cy="18"
										r="8"
										fill="white"
										opacity="0.9"
									/>
									<path
										d="M24 28C16 28 10 32 10 38V42H38V38C38 32 32 28 24 28Z"
										fill="white"
										opacity="0.9"
									/>
									<path
										d="M30 16L34 12M18 16L14 12M24 10V6"
										stroke="white"
										strokeWidth="2"
										strokeLinecap="round"
										opacity="0.7"
									/>
								</svg>
							</div>
							<h3 className="text-2xl font-bold mb-4 text-white">
								{t('page.dopplemate.ait7')}
							</h3>
							<p className="text-gray-300">{t('page.dopplemate.ait8')}</p>
						</div>
						<div
							data-observe
							className={`text-center p-8 bg-gradient-to-br from-purple-900/20 to-pink-900/20 rounded-3xl border border-purple-500/20 transition-all duration-700 ${
								visibleSections.has('ai-profile')
									? 'opacity-100 translate-x-0'
									: 'opacity-0 translate-x-10'
							}`}
							style={{ transitionDelay: '400ms' }}
						>
							<div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center">
								<svg
									width="48"
									height="48"
									viewBox="0 0 48 48"
									fill="none"
								>
									<rect
										x="14"
										y="8"
										width="20"
										height="32"
										rx="4"
										fill="white"
										opacity="0.2"
									/>
									<circle
										cx="24"
										cy="20"
										r="6"
										fill="white"
										opacity="0.9"
									/>
									<path
										d="M18 28C18 26 20.5 24 24 24C27.5 24 30 26 30 28V32H18V28Z"
										fill="white"
										opacity="0.9"
									/>
									<circle
										cx="24"
										cy="36"
										r="1.5"
										fill="white"
										opacity="0.6"
									/>
									<path
										d="M20 10H28"
										stroke="white"
										strokeWidth="1.5"
										strokeLinecap="round"
										opacity="0.4"
									/>
								</svg>
							</div>
							<h3 className="text-2xl font-bold mb-4 text-white">
								{t('page.dopplemate.ait9')}
							</h3>
							<p className="text-gray-300">{t('page.dopplemate.ait10')}</p>
						</div>
					</div>
				</div>
			</section>

			{/* AI Pet Section */}
			<section
				id="ai-pet"
				data-observe
				className={`relative py-32 px-6 lg:px-12 transition-all duration-1000 will-change-[opacity,transform] ${
					visibleSections.has('ai-pet')
						? 'opacity-100 translate-y-0'
						: 'opacity-0 translate-y-20'
				}`}
			>
				<div className="container mx-auto relative z-10 text-center">
					<div className="inline-flex items-center px-6 py-3 bg-amber-500/10 rounded-full border border-amber-400/20 mb-6">
						<span className="text-amber-300 text-sm font-medium tracking-wide">
							{t('page.dopplemate.pet1')}
						</span>
					</div>
					<h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-to-r from-white via-amber-200 to-orange-200 text-transparent bg-clip-text">
						{t('page.dopplemate.pet2')}
					</h2>
					<p className="text-lg text-gray-300 max-w-3xl mx-auto">
						<span className="text-amber-400 font-semibold">
							{t('page.dopplemate.pet3')}
						</span>
						{t('page.dopplemate.pet4')}
					</p>
				</div>
			</section>
		</div>
	)
}

export default Dopplemate
